import React, { useEffect, useState } from 'react'
import { isEmpty, map, size, slice } from 'lodash'

import EventCard from './EventCard'
import {
  enableLoadMoreEventCards as enableLoadMore,
  eventCardsPerPage as cardsPerPage,
} from '../../configuration/configs'
import labels from '../../configuration/labels'

import '../../styles/scss/components/grid/event-cards.scss'

const EventCards = ({ events }) => {
  const [numVisibleCards, setNumVisibleCards] = useState(cardsPerPage)

  useEffect(() => {
    setNumVisibleCards(cardsPerPage)
  }, [events])

  function onShowMoreCards() {
    setNumVisibleCards((value) => value + cardsPerPage)
  }

  const visibleEvents = enableLoadMore ? slice(events, 0, numVisibleCards) : events
  const showLoadMore = enableLoadMore && numVisibleCards < size(events)

  return (
    <div className="events-container">
      {isEmpty(visibleEvents) ? (
        <span className="events-unavailable">{labels.eventCardsEventsUnavailable}</span>
      ) : (
        <div className="event-cards">
          {map(visibleEvents, (event, index) => (
            <EventCard key={index} event={event} />
          ))}
        </div>
      )}
      {showLoadMore && (
        <button className="load-more" onClick={onShowMoreCards}>
          {labels.eventCardsCtaLoadMore}
          <div className="load-more-arrow" />
        </button>
      )}
    </div>
  )
}

export default EventCards
